import Model from './Model';

export default class EmployeeLogout extends Model {
    resource() {
        return 'employees/logout';
    }
}
